<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    
    <template v-slot:activator="{ on }">
       <v-btn v-if="id" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      
      <v-btn v-else 
        :fab="!Boolean(category)"
        :dark="!Boolean(category)"
        small 
        :color="!Boolean(category) ? 'primary' : ''"
        v-on="on"
        :icon="Boolean(category)"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>
      
      <v-card-text class="mt-7"><v-form ref="form" v-model="isValid">
      <v-row dense>
        <v-col cols="12" v-if="Boolean(serverError)">
          <v-alert 
            dense 
            outlined
            type="error" 
            transition="scale-transition"
          >
            {{ serverError }}
          </v-alert>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Наименование *"
            v-model="service.name"
            filled
            @focus="serverError = false"
            :rules="[v => !!v || 'Введите название работы.']"
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Ед. измерения *"
            v-model="service.unitName"
            :items="unitNames"
            clearable
            filled
            :rules="[v => !!v || 'Выберите ед. измерения.']"
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Категория *"
            v-model="service.categoryName"
            :items="servicesCategories"
            clearable
            filled
            :rules="[v => !!v || 'Выберите категорию.']"
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Подкатегория *"
            v-model="service.subCategoryName"
            :items="servicesSubCategories"
            clearable
            filled
            :rules="[v => !!v || 'Выберите подкатегорию.']"
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
          <v-text-field
            label="Цена за ед. *"
            v-model="service.pricePerUnit"
            filled
            :rules="[v => (v == '0') || !!v || 'Введите цену упаковки.', v => isNumber(v) || 'Цена должна быть числом.']"
            append-icon="mdi-currency-rub"
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-select
            label="Параметр объекта"
            v-model="service.objectParamTag"
            :items="objectParams"
            clearable
            filled
          ></v-select>
        </v-col><v-col cols="12">
          <v-select
            label="Этапы работ"
            v-model="service.stages"
            :items="stages"
            clearable
            filled
            multiple
          ></v-select>
        </v-col><v-col cols="12">
          <v-textarea
            label="Описание и комментарии"
            v-model="service.description"
            filled
          ></v-textarea>
        </v-col><v-col cols="12">
          <connected-materials :materials="service.materials"></connected-materials>
        </v-col><v-col cols="12">
          <text-chips label="Redirect" :value="service.redirectTable"></text-chips>
        </v-col>
        
      </v-row>
      </v-form></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
        >Сохранить</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import ConnectedMaterials from './ConnectedMaterials';

export default {
  name: 'service-card',

  components: {
    ConnectedMaterials
  },

  props: {
    id: String,
    category: {
      type: String,
      default: ''
    },
    subCategory: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeMode: false,
      isValid: false,
      title: this.id ? 'Карточка работы' : 'Создание работы',
      service: this.id ? 
        _.cloneDeep(this.$store.getters['prices/getServiceById'](this.id)) : 
        this.setDefaultObj(),
      serverError: false
    }
  },

  methods: {
    setDefaultObj() {
      return {
        name: '',
        unitName: '',
        pricePerUnit: 1,
        categoryName: this.category, // 1-ый уровень
        subCategoryName: this.subCategory, // 2-ой уровень
        materials: [],
        // Этапы производства на которых применяется данная работа
        stages: [],
        // Тэг параметра объекта (например: floor-area - площадь пола)
        objectParamTag: '',
        description: '',
        redirectTable: []
      }
    },

    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        try {
          if (this.id) this.$store.commit('prices/UPDATE_SERVICE', this.service)
          else this.$store.commit('prices/CREATE_SERVICE', this.service);
          this.$store.dispatch('showMessage', 'Работа успешно сохранена.');
          this.closeForm();
        } catch(err) {
          this.serverError = err.message;
          this.scrollUp();
        }
      }
    },

    closeForm() {
      this.scrollUp();
      this.activeMode = false;
      this.service = this.id ? 
        _.cloneDeep(this.$store.getters['prices/getServiceById'](this.id)) : 
        this.setDefaultObj();
      this.$refs.form.resetValidation();
      this.serverError = false;
    }
  },

  watch: {
    
  },

  computed: {
    ...mapGetters('prices', ['unitNames', 'servicesCategories', 'stages']),
    ...mapState('prices', ['objectParams']),
    servicesSubCategories() {
      return this.$store.getters['prices/servicesSubCategories'](this.service.categoryName);
    }
  }
}
</script>